<template>
  <div>
    <span class="text-yellow"> NOTE: This procedure will overwrite the MSISDN configuration if duplicated</span>
    <b-row class="mb-5">
      <b-col lg="5" md="5" sm="5">
        <b-form-file
          v-model="csvFile"
          :state="Boolean(csvFile)"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
          accept=".csv, .xls, .xlsx"
          class="w-100 mt-3"
          size="sm"
          @change="onFileChange"
        ></b-form-file>
      </b-col>
      <b-col lg="7" md="7" sm="7">
        <div class="mt-3">
          <b-button variant="success"  size="sm" v-on:click="previewFunc()">Preview</b-button>
          <vue-json-to-csv :json-data="tableData" :csv-title="exportDataTitle">
            <b-button variant="secondary"  size="sm">Download Template</b-button>
          </vue-json-to-csv>
          <b-button variant="info"  size="sm" v-if="loadingStatus" v-on:click="uploadTemplate">Upload</b-button>
        </div>
      </b-col>
    </b-row>

    <div v-if="loadingStatus">
      <b-row>
        <b-col xl="8" lg="8" md="8" sm="12">

          <b-form-group
            label=""
            label-for="per-page-select"
            label-cols-sm="0"
            label-cols-md="0"
            label-cols-lg="0"
            label-align-sm="center"
            label-size="sm"
            class="mb-2"
          >
            <label for="per-page-select" class="mr-2 text-sm">Show</label>
            <b-form-select
              id="per-page-select"
              class="custom-table-entries"
              v-model="perPage"
              :options="pageOptions"
              v-on:input="changePageOption(perPage)"
              size="sm"
            ></b-form-select>
            <label for="per-page-select" class="ml-2 text-sm">entries</label>
          </b-form-group>

        </b-col>
        <b-col xl="4" lg="4" md="4" sm="12 customer-table-select">
          <b-form-group
            label=""
            label-for="filter-input"
            label-align-sm="right"
            label-size="sm "
            class="mb-0"
          >
            <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                class="mb-4"
              ></b-form-input>

            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        striped hover
        :items="tableData"
        :fields="tableColumns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        head-variant="light"
        table-class="text-nowrap"
        class="customer-table"
        sticky-header="true"
        show-empty
        responsive
        small
        @filtered="onFiltered"
      >
        <template #cell(action)="row">
           <span>
             <i class="fas fa-pen-nib mr-3 cursor-pointer text-success" v-b-modal.change-group
                v-on:click="changeGroupFunc(row.item.userName, row.item.group)"></i>
             <i class="fas fa-trash-alt cursor-pointer  text-danger" v-on:click="deleteUserInfo(row.item.userName)"></i>
           </span>
        </template>
      </b-table>

      <b-row class="mt-4">
        <b-col>
          <p class="ml-3"> {{ startPage }} - {{ fromPage }} of {{ totalRows }} </p>
        </b-col>
        <b-col xl="auto" md="auto" sm="auto ">
          <b-pagination
            class="flex-fill-custom pr-4 ml-3"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            v-on:input="paginationChanged(currentPage)"
            size="sm"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal centered size="lg" id="import-detail-msisdn" hide-footer title="Import Detail" class="import-detail-msisdn"
             cancel-title="Close" ok-variant="primary" ok-title="Submit">
      <ImportDetailMsisdn></ImportDetailMsisdn>
    </b-modal>
  </div>
</template>

<script>
    import administratorService from "../../../../common/api-services/administrator-service";
    import VueJsonToCsv from 'vue-json-to-csv'
  //  import ImportDetail from "../../../Components/Import-Detail";
    import ImportDetailMsisdn from "../../../Components/Import-Detail-Msisdn";
    export default {
        name: "LoadMSISDNs",
      components: {
        ImportDetailMsisdn,
//        ImportDetail,
          VueJsonToCsv},
      data() {
        return {
          csvFile: null,
          fileInfo: [],
          groupOption: [],
          loadingStatus: false,
          totalRows: 0,
          currentPage: 1,
          pageOptions: [10, 25, 50, 100],
          perPage: 10,
          tableColumns: [
            {key: 'MSISDN', label: 'MSISDN', sortable: true, sortDirection: 'desc'},
            {key: 'Group', label: 'GROUP', sortable: true, sortDirection: 'desc'},
          ],
          tableData: [],
          localData: [],
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
          filter: null,
          filterOn: [],
          startPage: 1,
          fromPage: 10,
          lastPage: 1,
          tableHeaderforBody: [],
          exportDataTitle: '',
          importStatus: []
        }
      },
      mounted() {

      },
      methods: {
        changePageOption(page) {
          this.fromPage = page
        },

        onFileChange(e) {
          this.fileInfo = e.target.files[0];
          this.exportDataTitle = this.fileInfo.name.split('.')[0];
          const reader = new FileReader();
          reader.onload = e => {
            let csvFile = e.target.result.replaceAll('"', '');
            let header = csvFile.split('\n')[0];
            this.readHeader(header);
            let body = [];
            for (let i = 1; i < csvFile.split('\n').length - 1; i++) {
              body.push(csvFile.split('\n')[i])
            }
            this.readBody(body);
          };
          reader.readAsText(this.fileInfo);
        },
        previewFunc() {
          this.loadingStatus = true;
        },

        readHeader(value) {
          this.tableHeaderforBody = value.split(',');
        },

        readBody(value) {
          this.tableData = [];
          for (let i = 0; i < value.length; i++) {
            let table_row = {};
            value[i].split(',').forEach((e, index) => {
              table_row[this.tableHeaderforBody[index]] = e
            });
            this.tableData.push(table_row);
            this.totalRows = this.tableData.length;
            if (this.totalRows < 10) {
              this.fromPage = this.totalRows
            }
          }
        },

        uploadTemplate() {
          this.importStatus = [];
          this.tableData.map(item => {
            administratorService.importMSISDNTemplate(item).then(res => {
              if (res !== null) {
                let responseMsg = '';
                if (Array.isArray(res)) {
                  responseMsg = res.join('<br/>');
                } else {
                  responseMsg = res
                }
                if (res.indexOf('FAIL') !== -1 || responseMsg.indexOf('Error') !== -1) {
                  this.importStatus.push({
                    status: false,
                    id: Number(item.MSISDN).toString(),
                    message: responseMsg
                  })
                } else {
                  this.importStatus.push({
                    status: true,
                    id: Number(item.MSISDN).toString(),
                    message: responseMsg
                  })
                }
              }
              this.$bvModal.show('import-detail-msisdn');
              setTimeout(() => {
                this.$root.$emit('import-detail-msisdn', this.importStatus);
              }, 300)
            })
          });
          setTimeout(() => {
            this.$toast.success('Import Complete!')
          }, 1000)
        },

        onFiltered(filteredItems) {
          this.totalRows = filteredItems.length
          this.currentPage = 1
        },
      }
    }
</script>

<style scoped>

</style>
